export default class RangeFilter {
    /**
     * @param {string} field
     * @param {boolean|array|null} value
     */
    constructor(field, value) {

        this.field = field;
        this.value = Array.from(value);
    }

    set(value){
        this.value = value;
        return this;
    }
    setMin(value){
        this.value[0] = value;
        return this;
    }

    setMax(value){
        this.value[1] = value;
        return this;
    }

}
